
















import { Component, Prop, Vue } from 'vue-property-decorator'
import Tooltip, { TooltipAlign, TooltipStyling } from '@/components/ui/Tooltip.vue'
import NavigationLink from '@/components/ui/navigation/NavigationLink.vue'

@Component({
    components: {
        NavigationLink,
        Tooltip,
    },
})
export default class NavigationBetaButton extends Vue {
    @Prop({ required: true }) route!: string
    @Prop({ required: true }) label!: string
    @Prop({ required: true }) icon!: string

    get tooltipProps() {
        return {
            align: TooltipAlign.CENTER,
            styling: TooltipStyling.BETA,
        }
    }
}
